<div [ngClass]="[breakPointSize === 'xl' ? 'tablet-footer-margin' : '']"></div>
@if (footerData$ | async; as footerData) {
<div class="shimano-footer" [ngClass]="[activeCountry$ | async, activeLanguage$ | async]">
  @for (link of footerData.links; track link; let footerLinkItem = $index) { @if
  (footerData.breakAfterIndex?.includes(footerLinkItem)) {
  <hr />
  }
  <app-generic-link
    location="footer"
    [linkIconSrc]="link.media"
    linkIconStyleClass="footer-link-icon"
    [url]="link.url"
    [target]="link.target ? '_blank' : null"
    >{{ link.linkName }}</app-generic-link
  >
  }
</div>
}
